import { Box, Button } from '@nimbus-ds/components';
import { RocketIcon, DiscountCircleIcon, HistoryIcon } from '@nimbus-ds/icons';
import { InitialScreen } from '@nimbus-ds/patterns';
import { useNavegate } from 'App/hooks';
import { useTranslationMarketing } from 'domains/Marketing/hook';
import { MARKETING_ROUTES } from 'domains/Marketing/marketingRoutes';
import {
  SectionAppCard,
  SectionAppCardDomains,
} from 'domains/PartnersApps/components';
import emptyPromotionsImage from './empty-promotions.png';

interface PromotionsListEmptyProps {
  onCreate?: () => void;
}

export function PromotionsListEmpty({ onCreate }: PromotionsListEmptyProps) {
  const t = useTranslationMarketing('promotions.emptyResults');
  const { goTo } = useNavegate();
  const handlePrimary =
    onCreate || (() => goTo(MARKETING_ROUTES.newPromotions));
  return (
    <InitialScreen>
      <InitialScreen.Hero
        subtitle={t('subtitle').toUpperCase()}
        title={t('title')}
        bullets={[
          <InitialScreen.Bullet
            key="bullet1"
            icon={<RocketIcon />}
            text={t('bullet1')}
          />,
          <InitialScreen.Bullet
            key="bullet2"
            icon={<DiscountCircleIcon />}
            text={t('bullet2')}
          />,
          <InitialScreen.Bullet
            key="bullet3"
            icon={<HistoryIcon />}
            text={t('bullet3')}
          />,
        ]}
        image={
          <img
            src={emptyPromotionsImage}
            width="100%"
            height="auto"
            alt={t('subtitle')}
          />
        }
        actions={
          <Button onClick={handlePrimary} appearance="primary">
            {t('action')}
          </Button>
        }
      >
        <Box>
          <SectionAppCard
            source={MARKETING_ROUTES.promotionsList}
            appCategory="marketing"
            domain={SectionAppCardDomains.PROMOTIONS}
          />
        </Box>
      </InitialScreen.Hero>
    </InitialScreen>
  );
}
